import React from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { SettingAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import htmlToDraft from 'html-to-draftjs';
import { checkPermissions } from 'hooks';

import {
    // CompositeDecorator,
    // ContentBlock,
    ContentState,
    // Editor,
    EditorState,
    //convertFromHTML,
    convertToRaw,
} from 'draft-js';


export const SaveButton = (props) => {
    return (
        <>
            {checkPermissions(props.loginData, 'update_static_pages') ?
                <Button
                    style={{ width: 200, marginLeft: 'auto' }}
                    color="primary"
                    className="border-0"
                    block
                    onClick={() => {
                        props.saveSetting({ data_key: props.data_key, data: props.pageText })
                    }} > Save </Button>
                : <Button
                    style={{ width: 200, marginLeft: 'auto' }}
                    color="primary"
                    className="border-0 btn-disabled"
                    block
                    disabled={true}> Save </Button>
            }
        </>
    )
}


const Main = (props) => {


    const [pageText, setPageText] = React.useState('');

    const [editorState, setEditorState] = React.useState(() =>
        EditorState.createEmpty()
    );

    React.useEffect(() => {
        props.getSetting({ data_key: props.data_key });
    },[props.data_key])

    React.useEffect(() => {
        const getData = (props.settingData && props.settingData.data) ? props.settingData.data : '';
        setPageText(getData);
        const contentBlock = htmlToDraft(getData);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
        /*const blocksFromHTML = convertFromHTML(getData);
        const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        );
        setEditorState(EditorState.createWithContent(
            editorState
        ))*/
        //}
    }, [props.settingData]);

    const handleEditorChange = (state) => {
        setEditorState(state);
        sendContent();
    };

    const sendContent = () => {
        const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        setPageText(data);
    };

    const [isFixed, setIsFixed] = React.useState(false);

    const toggleToolbar = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 200) {
            setIsFixed(true)
        }
        else if (scrolled <= 200) {
            setIsFixed(false)
        }
    };

    window.addEventListener('scroll', toggleToolbar);

    return (
        <div>
            {(props.isLoading) ? <PageSpinner />

                : <div>
                    <div style={{ marginBottom: 10 }}>
                        <SaveButton {...props} pageText={pageText} />
                    </div>
                    <Form>
                        <FormGroup>

                            <Editor
                                editorState={editorState}
                                onEditorStateChange={handleEditorChange}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName={(isFixed) ? "toolbar-class toolbar-fixed" : "toolbar-class"}
                                toolbar={{
                                    options: [
                                        'inline',
                                        'fontFamily',
                                        'fontSize',
                                        'list',
                                        'textAlign',
                                        'link',
                                        'blockType'
                                    ],
                                    blockType: {
                                        inDropdown: true,
                                        options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                                        className: undefined,
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    inline: {
                                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    list: {
                                        options: ['unordered', 'ordered'],
                                    },
                                    fontSize: {
                                        options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                    },
                                    fontFamily: {
                                        options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana',"Sofia Pro", 'Noto Sans Symbols, sans-serif'],
                                    },
                                }}
                            />
                        </FormGroup>
                        <div>
                            <SaveButton {...props} pageText={pageText} />
                        </div>
                    </Form >
                </div>
            }
        </div >
    );
}

const mapStateToProps = (state) => ({

    settingData: (state.setting && state.setting.settingData && state.setting.settingData.data) ? state.setting.settingData.data : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getSetting: (payload) => dispatch(SettingAction.getSetting(payload)),
    saveSetting: (payload) => dispatch(SettingAction.saveSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
